<template>
    <b-popover
        :target="propId"
        v-bind="$attrs"
        :show.sync="show"
        @shown="showDp"
        @hidden="skipUpdate = 0"
        triggers="click blur"
        placement="bottom"
        custom-class="btn-calendar"
        class="buttonCalendar"
        container="app"
    >
        <date-picker
            ref="datepicker"
            :id="'dp_' + propId"
            v-model="myDate"
            :config="options"
            @dp-change.stop.prevent="dateChange"
            @dp-update.stop.prevent="onUpdate"
            :class="{ weekly: weekly }"
        ></date-picker>
    </b-popover>
</template>
<style>
.weekly .bootstrap-datetimepicker-widget .datepicker-days table tbody tr:hover {
    background-color: #eee;
}

.weekly .bootstrap-datetimepicker-widget .datepicker-days table > tr td.active {
    background-color: red;
}
.weekly .bootstrap-datetimepicker-widget table td.day {
    height: 18px;
    line-height: 18px;
    width: 20px;
    border-radius: 0;
}
.weekly .bootstrap-datetimepicker-widget table td.day:hover {
    background-color: #eee;
}
</style>
<script>
export default {
    props: {
        propId: {
            type: String
        },
        change: {
            type: Function
        },
        weekly: {
            type: Boolean
        },
        date: {
            type: [Object, Date] // moment | Date
        },
        monthly: {
            type: Boolean
        }
    },
    data() {
        return {
            resources: {},
            options: {
                inline: true,
                format: this.monthly ? "MM/YYYY" : "DD/MM/YYYY",
                useCurrent: false,
                timeZone: null
            },
            show: false,
            myDate: new Date(),
            skipUpdate: 0
        };
    },
    watch: {
        date(newValue) {
            this.skipUpdate = 1;
            this.myDate = newValue;
        }
    },
    created() {
        if (this.monthly) {
            this.options.format = "MM/YYYY";
            this.options.viewMode = "months";
        } else {
            this.options.format = this.getDateFormat();
        }

        this.options.timeZone = this._timeZone;
    },
    methods: {
        showDp() {
            let self = this;
            this.skipUpdate = 0;
            this.options.timeZone = this._timeZone;
            this.options.format = this.monthly
                ? "MM/YYYY"
                : this.getDateFormat();

            // ensure the element is loaded
            setTimeout(() => {
                $("#dp_" + this.propId + " td.day.active").on(
                    "click",
                    event => {
                        event.date = self.$refs["datepicker"].dp.viewDate();
                        self.$emit("change", event);
                    }
                );
            }, 500);
        },
        dateChange(event) {
            let self = this;
            this.show = false;
            if (this.skipUpdate > 0) {
                this.skipUpdate--;
                return;
            }
            this.$emit("change", event);
        },
        onUpdate(event) {
            this.$emit("update", event);
        }
    }
};
</script>
